import { createStore } from 'vuex';

export const store = createStore({
  state: {
    token: null,
    refresh_token: null,
    user_id: null,
    picture_url: null,
    email: null,
    name: null
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    CLEAR_TOKEN(state) {
      state.token = null;
    },
    SET_REFRESH_TOKEN(state, token) {
      state.refresh_token = token;
    },
    CLEAR_REFRESH_TOKEN(state) {
      state.refresh_token = null;
    },
    SET_USER_ID(state, userId) {
      state.user_id = userId;
    },
    CLEAR_USER_ID(state) {
      state.user_id = null;
    },
    SET_EMAIL(state, email) {
      state.email = email;
    },
    CLEAR_EMAIL(state) {
      state.email = null;
    },
    SET_NAME(state, name) {
      state.name = name;
    },
    CLEAR_NAME(state) {
      state.name = null;
    },
    SET_PICTURE_URL(state, pictureUrl) {
      state.picture_url = pictureUrl;
    },
    CLEAR_PICTURE_URL(state) {
      state.picture_url = null;
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit('SET_TOKEN', token);
    },
    clearToken({ commit }) {
      commit('CLEAR_TOKEN');
    },
    setRefreshToken({ commit }, token) {
      commit('SET_REFRESH_TOKEN', token);
    },
    clearRefreshToken({ commit }) {
      commit('CLEAR_REFRESH_TOKEN');
    },
    setUserId({ commit }, userId) {
      commit('SET_USER_ID', userId);
    },
    clearUserId({ commit }) {
      commit('CLEAR_USER_ID');
    },
    setEmail({ commit }, email) {
      commit('SET_EMAIL', email);
    },
    clearEmail({ commit }) {
      commit('CLEAR_EMAIL');
    },
    setName({ commit }, name) {
      commit('SET_NAME', name);
    },
    clearName({ commit }) {
      commit('CLEAR_NAME');
    },
    setPictureUrl({ commit }, pictureUrl) {
      commit('SET_PICTURE_URL', pictureUrl);
    },
    clearPictureUrl({ commit }) {
      commit('CLEAR_PICTURE_URL');
    }
  },
  getters: {
    token: state => state.token,
    refresh_token: state => state.refresh_token,
    userId: state => state.user_id,
    email: state => state.email,
    name: state => state.name,
    pictureUrl: state => state.picture_url
  }
});

